import React from 'react'
import { FlexView } from 'components/common'
import Header from 'containers/layout/Header'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import PrivateRoute from 'containers/router/PrivateRoute'
import { TubularProvider } from 'stores/TubularStore'
import Home from 'pages/Home'
import Login from 'pages/Login'
import PurchaseOrder from 'pages/PurchaseOrder'
import Invoice from 'pages/Invoice'
import Ippn from 'pages/Ippn'
import Sot from 'pages/Sot'
import Reservation from 'pages/Reservation'
import SalesOrder from 'pages/SalesOrder'

const Router = () => {
  return (
    <FlexView height="100vh">
      <BrowserRouter>
        <Header />
        <Switch>
          <Route path="/login" exact>
            <Login />
          </Route>
          <PrivateRoute path="/">
            <TubularProvider>
              <Switch>
                <PrivateRoute path="/home" exact>
                  <Home />
                </PrivateRoute>
                <PrivateRoute path="/" exact>
                  <Home />
                </PrivateRoute>
                <PrivateRoute path="/invoice" exact>
                  <Home />
                </PrivateRoute>
                <PrivateRoute path="/invoice/:invoiceId" exact>
                  <Invoice />
                </PrivateRoute>
                <PrivateRoute path="/purchaseOrder" exact>
                  <Home />
                </PrivateRoute>
                <PrivateRoute path="/purchaseOrder/:purchaseId" exact>
                  <PurchaseOrder />
                </PrivateRoute>
                <PrivateRoute path="/salesOrder" exact>
                  <Home />
                </PrivateRoute>
                <PrivateRoute path="/salesOrder/:salesId" exact>
                  <SalesOrder />
                </PrivateRoute>
                <PrivateRoute path="/ippn" exact>
                  <Home />
                </PrivateRoute>
                {/* <PrivateRoute path="/ippn/:ippnId" exact>
                  <Ippn />
                </PrivateRoute> */}
                <PrivateRoute path="/ippn/:ippnId/valid/:validId" exact>
                  <Ippn />
                </PrivateRoute>
                <PrivateRoute path="/ippn/:ippnId" exact>
                  <Ippn />
                </PrivateRoute>
                <PrivateRoute path="/valid" exact>
                  <Home />
                </PrivateRoute>
                <PrivateRoute path="/valid/:validId" exact>
                  <Ippn />
                </PrivateRoute>
                <PrivateRoute path="/sot/:sotId" exact>
                  <Sot />
                </PrivateRoute>
                <PrivateRoute path="/sot" exact>
                  <Home />
                </PrivateRoute>
                <PrivateRoute path="/reservation/:reservationId" exact>
                  <Reservation />
                </PrivateRoute>
                <PrivateRoute path="/reservation" exact>
                  <Home />
                </PrivateRoute>
                <PrivateRoute path="/">
                  <Redirect to="/" />
                </PrivateRoute>
              </Switch>
            </TubularProvider>
          </PrivateRoute>
        </Switch>
      </BrowserRouter>
    </FlexView>
  )
}

export default Router